import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-middle" }
const _hoisted_4 = { class: "footer-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"widget\"><h4 class=\"widget-title\">Headquarters</h4> 9418 Norton<br> Commons Blvd<br> Suite 206<br> Prospect, KY 40059 </div><div class=\"widget\"><h4 class=\"widget-title\">Learn</h4><a href=\"https://handleglobal.blog/\">Blog</a></div>", 2)
const _hoisted_7 = { class: "widget widget-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "widget-title" }, "Buy & Sell", -1)
const _hoisted_9 = { class: "links" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Buying")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Selling")
const _hoisted_12 = { class: "widget widget-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "widget-title" }, "Support", -1)
const _hoisted_14 = { class: "links" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("FAQS")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Contact Us")
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"widget widget-sm\"><h4 class=\"widget-title\">Get Social</h4><ul class=\"links\"><li><a href=\"https://www.facebook.com/Healthcare-Asset-Network-289981404875503/\">Facebook</a></li><li><a href=\"https://www.linkedin.com/company/handleglobal/\">LinkedIn</a></li><li><a href=\"https://twitter.com/HandleGlobal\">Twitter</a></li><li><a href=\"https://www.youtube.com/channel/UCsNxEFu42wXQRsJwyJI2Imw\">YouTube</a></li><li><a href=\"https://www.instagram.com/handle_global/\">Instagram</a></li></ul></div>", 1)
const _hoisted_18 = { class: "footer-bottom d-sm-flex align-items-center" }
const _hoisted_19 = { class: "footer-left" }
const _hoisted_20 = { class: "footer-copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.SHOP }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.LOGIN }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.FAQ }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.CONTACT }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, "© " + _toDisplayString(_ctx.year) + " HANDLE Global. All rights reserved.", 1)
          ])
        ])
      ])
    ])
  ]))
}